import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLike, curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {UnaryMathOperatorParameters} from "#template/nodes/geometry-graph/attribute/unary-math-operator/geometry-unary-math-operator-node"
import {
    GeometryUnaryMathOperatorNode,
    unaryMathOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute/unary-math-operator/geometry-unary-math-operator-node"

export type CurveGeometryUnaryMathOperatorParameters = UnaryMathOperatorParameters<CurveGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryUnaryMathOperatorParameters> = {
    nodeClass: "CurveGeometryUnaryMathOperator",
    validation: {
        parameters: unaryMathOperatorParametersSchema(curveGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryUnaryMathOperator extends GeometryUnaryMathOperatorNode<1, CurveGeometryAttributeLikeNode> implements CurveGeometryAttributeLikeNode {
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
